<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="row clearfix breadcrumb-margin-lg">
        <div class="col-md-6 col-sm-12 mt-1">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item active" aria-current="page">Category</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-6 col-sm-12 text-right hidden-xs">
          <!-- <router-link
                :to="'/admin/category/add'"
                class="btn btn-sm btn-info"
                title="Add New Category"><i class="fa fa-plus pr-1"></i>Add Category</router-link>
           -->
        </div>
      </div>
    </div>

    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card body-margin">
          <!-- <div class="header">
            <ul class="header-dropdown dropdown">
               <li>
                  <a href="javascript:void(0);" class="full-screen"
                    ><i class="icon-frame"></i
                  ></a>
                </li>
            </ul>
          </div> -->

          <div class="body">
            <v-app>
              <div>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    outlined
                    dense
                    hide-details
                    class="br-radius top-fix"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-card class="mx-auto" tile>
                    <!-- <v-card-title>Category Details</v-card-title> -->
                    <v-data-table
                      :headers="headers"
                      :items="categories"
                      loading-text="Loading... Please wait"
                      :search="search"
                      class="elevation-0"
                      :loading="loading"
                      hide-default-footer
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <div class="dropdown">
                          <a
                            href="javascript:void(0);"
                            class="dropdown-toggle icon-menu btn btn-primary text-white"
                            data-toggle="dropdown"
                            ><strong>Actions</strong></a
                          >

                          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li title="Add Category" class="dropdown-item pt-1 pb-1">
                              <a @click="categoryfilter(item.domain_id)">
                                <i class="fa fa-plus mr-3" aria-hidden="true"></i>Add Category
                              </a>
                            </li>
                            <li title="Edit" class="dropdown-item pt-1 pb-1">
                              <a @click="editCategory(item.category_id)">
                                <i class="fa fa-edit mr-3" aria-hidden="true"></i>
                                Edit</a
                              >
                            </li>
                            <li title="Delete" class="dropdown-item pt-1 pb-1">
                              <a @click="deleteCategory(item.category_id)">
                                <i class="fa fa-trash mr-3" aria-hidden="true"></i>Delete</a
                              >
                            </li>
                            <li class="dropdown-item pt-1 pb-1">
                              <a
                                @click="ToggleCategoryActiveStatus(item.category_id)"
                                v-if="item.category_isactive == 'Y'"
                                title="Deactivate"
                              >
                                <i class="fa fa-toggle-on mr-3" aria-hidden="true"></i>
                                Deactivate</a
                              >
                              <a
                                @click="ToggleCategoryActiveStatus(item.category_id)"
                                v-if="item.category_isactive == 'N'"
                                title="Activate"
                                ><i class="fa fa-toggle-on mr-3" aria-hidden="true"></i> Activate</a
                              >
                            </li>
                          </div>
                        </div>
                      </template>
                    </v-data-table>
                    <v-pagination v-model="currentPage" :length="lastPage" :total-visible="8">
                    </v-pagination>
                  </v-card>
                </v-col>
              </div>
            </v-app>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataService from '../../../dataservice';
export default {
  data() {
    return {
      categories: [],
      loading: true,
      totalItems: 0,
      currentPage: 1,
      lastPage: 0,
      search: '',
      headers: [
        { text: 'Category Id', value: 'category_id' },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: 'Domain', value: 'domain_title' },

        { text: 'Category Name', value: 'category_title' },
        { text: 'Description', value: 'category_description' },
        { text: 'Active Status', value: 'category_isactive' },
      ],
    };
  },
  //this one will populate new data set when user changes current page.
  watch: {
    currentPage() {
      this.readData();
    },
  },
  methods: {
    readData() {
      this.loading = true;
      DataService.getCategory(this.currentPage)
        .then(response => {
          this.categories = response.data.data;
          this.totalItems = response.data.total;
          this.loading = false;
          this.currentPage = response.data.current_page;
          this.lastPage = response.data.last_page;
        })
        .catch(e => {
          // console.log(e);
        });
    },
    editCategory(id) {
      this.$router.push({ name: 'EditCategory', params: { id: id } });
    },
    categoryfilter(id) {
      this.$router.push({ name: 'CategoryFilter', params: { id: id } });
    },
    ToggleCategoryActiveStatus(id) {
      DataService.CategoryActiveStatusToggle(id).then(response => {
        this.s('Category', 'Status has been updated successfully.');
        this.refreshList();
      });
    },
    deleteCategory(id) {
      DataService.deleteCategory(id).then(response => {
        this.s('Record Deleted');
        this.refreshList();
      });
    },
    refreshList() {
      this.readData();
    },
  },
  mounted() {
    this.readData();
  },
};
</script>
<style scoped>
.top-fix {
  margin-top: -48px !important;
  margin-bottom: -16px !important;
}
.body-margin {
  margin-top: -24px !important;
}
</style>
